<script>
import ScheduledMessagesAPI from 'dashboard/api/scheduledMessages';
import ScheduleSendModal from 'dashboard/components/widgets/WootWriter/ScheduleSendModal.vue';

export default {
  name: 'ScheduledMessagesPanel',
  components: { ScheduleSendModal },
  props: {
    accountId: { type: Number, required: true },
    conversationId: { type: Number, required: true },
  },
  data() {
    return {
      loading: true,
      items: [],
      editing: null,
    };
  },
  mounted() {
    this.fetch();
  },
  watch: {
    conversationId() {
      this.fetch();
    },
  },
  methods: {
    async fetch() {
      if (!this.accountId || !this.conversationId) return;
      this.loading = true;
      try {
        const { data } = await ScheduledMessagesAPI.get({
          accountId: this.accountId,
          conversationId: this.conversationId,
        });
        this.items = data || [];
      } finally {
        this.loading = false;
      }
    },
    formatDate(iso) {
      if (!iso) return '';
      return new Date(iso).toLocaleString();
    },
    openEdit(item) {
      this.editing = { ...item };
      // open modal prefilled
      this.$refs.scheduleModal.open({
        content: this.editing.content,
      });
      // set default datetime-local value by patching modal field after nextTick
      this.$nextTick(() => {
        const dt = new Date(this.editing.scheduled_at);
        const pad = n => `${n}`.padStart(2, '0');
        const yyyy = dt.getFullYear();
        const mm = pad(dt.getMonth() + 1);
        const dd = pad(dt.getDate());
        const hh = pad(dt.getHours());
        const mi = pad(dt.getMinutes());
        // set modal local field if present
        if (this.$refs.scheduleModal) {
          this.$refs.scheduleModal.draftDateTimeLocal = `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
        }
      });
    },
    async applyEdit({ content, scheduledAtISO }) {
      await ScheduledMessagesAPI.update({
        accountId: this.accountId,
        conversationId: this.conversationId,
        id: this.editing.id,
        scheduled_message: { content, scheduled_at: scheduledAtISO },
      });
      this.editing = null;
      this.fetch();
      this.$store.dispatch('setToastMessage', { message: 'Rescheduled' });
    },
    async cancel(item) {
      await ScheduledMessagesAPI.delete({
        accountId: this.accountId,
        conversationId: this.conversationId,
        id: item.id,
      });
      this.fetch();
      this.$store.dispatch('setToastMessage', { message: 'Canceled' });
    },
  },
};
</script>

<template>
  <div class="">
    <div v-if="loading" class="text-xs opacity-70">Loading…</div>
    <div v-else-if="!items.length" class="text-xs opacity-70">No scheduled messages.</div>

    <div v-else class="relative flex items-start flex-grow-0 flex-shrink-0 w-auto max-w-full py-0 border-t-0 border-b-0 border-l-0 border-r-0 border-transparent border-solid cursor-pointer conversation hover:bg-n-alpha-1 dark:hover:bg-n-alpha-3 group px-0" v-for="item in items" :key="item.id">
	<div class="relative" @mouseenter="onThumbnailHover" @mouseleave="onThumbnailLeave"></div>
	<div class="px-0 py-3 border-b group-hover:border-transparent flex-1 border-n-slate-3 min-w-0">
		<div class="flex items-center min-w-0 gap-1 mx-2">
			<div class="flex items-center text-n-slate-11 text-xs min-w-0 flex-1 min-w-0">
				<span class="i-ph-calendar-dot size-3 ltr:mr-1 rtl:ml-1 flex-shrink-0"></span>
				<span><strong class="capitalize">{{ item.status }}</strong></span>
			</div>
			<div class="flex items-center gap-2 flex-shrink-0">
				<span class="text-n-slate-11 text-xs font-medium leading-3 py-0.5 px-0 inline-flex items-center truncate">
					<fluent-icon icon="person" size="12" class="text-n-slate-11" />
						{{ formatDate(item.scheduled_at) }}
				</span>
			</div>
		</div>
		<h4 title="{{ item.content }}" class="conversation--user text-sm my-0 mx-2 capitalize pt-0.5 text-ellipsis overflow-hidden whitespace-nowrap flex-1 min-w-0 ltr:pr-16 rtl:pl-16 text-n-slate-12 font-semibold">{{ item.content }}</h4>
		<div class="my-2 mx-2 leading-6 h-8 flex-1 min-w-0 text-sm overflow-hidden text-ellipsis whitespace-nowrap text-n-slate-11" v-if="item.status == 'scheduled'">
			<button class="px-2 mr-4 py-1 rounded bg-slate-200 dark:bg-slate-700" @click="openEdit(item)">Edit</button>
			<button class="px-2 py-1 rounded bg-red-600 text-white" @click="cancel(item)">Cancel</button>
		</div>
	</div>
    </div>
    <!-- Reuse the same modal for editing -->
    <ScheduleSendModal ref="scheduleModal" @confirm="applyEdit" />
  </div>
</template>

<style scoped>
/* Leverages your existing utility styles */
</style>

